import { useUserCanAccess } from '@/hooks/auth';
import { PlaylistItem } from '@/prisma/utils/playlist';
import {
	Button, HStack
} from '@chakra-ui/react';

type PlaylistItemControlsProps = {
	playlistItem: PlaylistItem;
	onEditClick: () => void;
	onDeleteClick: () => void;
}

const PlaylistItemControls: React.FC<PlaylistItemControlsProps> = ({
	playlistItem, onEditClick, onDeleteClick 
}) => {
	const hasAccess = useUserCanAccess(playlistItem.playlist.owner);

	return (
		<>
			<HStack as="nav">
				<Button
					disabled={!hasAccess}
					onClick={onEditClick}
				>Edit</Button>
				<Button
					disabled={!hasAccess}
					onClick={onDeleteClick}
				>Delete</Button>
			</HStack>
		</>
	);
};

export default PlaylistItemControls;
